import zh from "./config/zh.js";
import en from "./config/en.js";
import ru from "./config/ru.js";
import fr from "./config/fr.js";
import it from "./config/it.js";
import es from "./config/es.js";
import pt from "./config/pt.js";
import ko from "./config/ko.js";
import ja from "./config/ja.js";
import ar from "./config/ar.js";
import id from "./config/id.js";

// import enLocale from 'element-ui/lib/locale/lang/en'
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
// import ruLocale from 'element-ui/lib/locale/lang/ru-RU'
// import frLocale from 'element-ui/lib/locale/lang/fr'

export const messages = {
  'zh-CN': {
    ...zh,
  },
  en: {
    ...en,
  },
  ru: {
    ...ru,
  },
  fr: {
    ...fr,
  },
  it: {
    ...it,
  },
  es: {
    ...es,
  },
  pt: {
    ...pt,
  },
  ko: {
    ...ko,
  },
  ja: {
    ...ja,
  },
  ar: {
    ...ar,
  },
  id: {
    ...id,
  },
};
